export default __webpack_public_path__ + "static/media/t3-black.68558f17.svg";